import styled from 'styled-components';

export const Container = styled.footer`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  justify-content: space-between;
  align-items: flex-start;
  background: #292929;
  padding: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 600px) {
    padding-bottom: 100px;
  }
`;

export const FooterSection = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 20px;
  flex: 1;

  @media (max-width: 768px) {
    margin: 20px 0;
    text-align: center;
  }
`;

export const FooterTitle = styled.h3`
  font-size: 1.2em;
  margin-bottom: 10px;
  color: #ccc;
`;

export const FooterItem = styled.li`
  margin-bottom: 8px;

  a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FooterBottom = styled.footer`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  font-size: 0.9em;
  color: #aaa;
  flex-basis: 100%;
  text-align: center;

  small {
    margin-top: 5px;
  }

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;
